import axios from 'axios';

import type { TRemoveOtherResponsibles } from '../../types/TLocation';

export default async function removeOtherResponsibles({
  accessToken,
  locationId,
  responsibleIds,
  setTokenLikeExpired,
  setIsRemovingResponsibles,
}: TRemoveOtherResponsibles) {
  try {
    if (setIsRemovingResponsibles) setIsRemovingResponsibles(true);
    const { data } = await axios.post(
      `${process.env.REACT_APP_LOCATIONS_API_URL}/other-responsibles/remove/${locationId}`,
      { responsibleIds },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    return data;
  } catch (err: any) {
    if (err.response?.status === 401 && setTokenLikeExpired) setTokenLikeExpired();

    return err;
  } finally {
    if (setIsRemovingResponsibles) setIsRemovingResponsibles(false);
  }
}
